import { Checkbox } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BUSINESS_ACCOUNT_BRANCH } from "src/utils/data/constant";

const ImagesPath = {
  KW: "/images/kuwait.png",
  SA: "/images/saudi-arabia.png",
  AE: "/images/emirat.png",
};

const SelectBranch = () => {
  const user = useSelector((state: any) => state?.user);
  const [showDropdown, setShowDropdown] = useState(false);
  const [branches, setBranches] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const dropdownElement = document.querySelector(".relative.flex");
      if (dropdownElement && !dropdownElement.contains(event.target as Node)) {
        setShowDropdown(false);
        if (localStorage.getItem("selectedBranches")) {
          setSelectedBranches(
            JSON.parse(localStorage.getItem("selectedBranches") || "[]")
          );
        } else {
          setSelectedBranches(user?.branches);
          localStorage.setItem(
            "selectedBranches",
            JSON.stringify(user?.branches)
          );
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (user) {
      setBranches(user?.branches || []);
    }
    if (localStorage.getItem("selectedBranches")) {
      setSelectedBranches(
        JSON.parse(localStorage.getItem("selectedBranches") || "[]")
      );
    } else {
      setSelectedBranches(user?.branches);
      localStorage.setItem("selectedBranches", JSON.stringify(user?.branches));
    }
  }, [user]);

  return (
    <div className="relative flex">
      <div
        onClick={() => setShowDropdown(!showDropdown)}
        className="cursor-pointer max-w-[100%] w-64 px-3 py-2 bg-white rounded-3xl border border-gray-100 justify-between items-center inline-flex"
      >
        <div className="justify-start items-center gap-1 flex">
          <div className="flex items-center gap-1 w-full text-sky-900 text-xs font-medium">
            {selectedBranches?.length ? (
              <div className="flex gap-1">
                <img
                  className="w-4 h-4"
                  src={ImagesPath[selectedBranches[0]]}
                  alt="kuwait-icon"
                />
                <span>{BUSINESS_ACCOUNT_BRANCH[selectedBranches[0]]}</span>
              </div>
            ) : (
              ""
            )}
            {selectedBranches?.length > 1 &&
              `+ ${selectedBranches?.length - 1}`}
          </div>
        </div>
        <img
          className="w-4 h-4"
          src="/images/arrow-down.svg"
          alt="arrow-down-icon"
        />
      </div>

      {showDropdown && (
        <div className="z-10 absolute top-[2.28rem] w-64 bg-white rounded-lg shadow-[0px_1px_2px_0px_rgba(0,0,0,0.25)] border border-neutral-200 flex-col justify-start items-start inline-flex overflow-hidden">
          {branches?.includes("KW") && (
            <div className="self-stretch h-10 flex-col justify-start items-start flex">
              <div className="self-stretch px-4 py-2 bg-white justify-between items-center gap-2 inline-flex">
                <Checkbox
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedBranches((prev) => [...prev, "KW"]);
                    } else {
                      setSelectedBranches((prev) =>
                        prev.filter((b) => b !== "KW")
                      );
                    }
                  }}
                  checked={selectedBranches.includes("KW")}
                >
                  <div className="grow shrink basis-0 flex-col justify-start items-start inline-flex">
                    <div className="self-stretch h-5 text-neutral-800 text-sm font-medium">
                      Kuwait
                    </div>
                  </div>
                </Checkbox>

                <div className="w-6 h-6 justify-center items-center flex">
                  <img className="w-6 h-6" src="/images/kuwait.png" />
                </div>
              </div>
            </div>
          )}
          {branches?.includes("SA") && (
            <div className="self-stretch h-10 flex-col justify-start items-start flex">
              <div className="self-stretch px-4 py-2 bg-white justify-between items-center gap-2 inline-flex">
                <Checkbox
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedBranches((prev) => [...prev, "SA"]);
                    } else {
                      setSelectedBranches((prev) =>
                        prev.filter((b) => b !== "SA")
                      );
                    }
                  }}
                  checked={selectedBranches.includes("SA")}
                >
                  <div className="grow shrink basis-0 flex-col justify-start items-start inline-flex">
                    <div className="self-stretch h-5 text-neutral-800 text-sm font-medium">
                      Saudi Arabia
                    </div>
                  </div>
                </Checkbox>

                <div className="w-6 h-6 justify-center items-center flex">
                  <img className="w-6 h-6" src="/images/saudi-arabia.png" />
                </div>
              </div>
            </div>
          )}
          {branches?.includes("AE") && (
            <div className="self-stretch h-10 flex-col justify-start items-start flex">
              <div className="self-stretch px-4 py-2 bg-white justify-between items-center gap-2 inline-flex">
                <Checkbox
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedBranches((prev) => [...prev, "AE"]);
                    } else {
                      setSelectedBranches((prev) =>
                        prev.filter((b) => b !== "AE")
                      );
                    }
                  }}
                  checked={selectedBranches.includes("AE")}
                >
                  <div className="grow shrink basis-0 flex-col justify-start items-start inline-flex">
                    <div className="self-stretch h-5 text-neutral-800 text-sm font-medium">
                      United Arab Emirates
                    </div>
                  </div>
                </Checkbox>

                <div className="w-6 h-6 justify-center items-center flex">
                  <img className="w-6 h-6" src="/images/emirat.png" />
                </div>
              </div>
            </div>
          )}
          <div className="w-full h-12 flex-col justify-between items-start flex border-t-[1px] border-[#E4E2E4]">
            <div className="self-stretch h-10 px-4 py-2 bg-white justify-between items-center gap-1 inline-flex">
              <div className="justify-start items-start gap-4 flex">
                <div
                  onClick={() => setSelectedBranches(branches)}
                  className="cursor-pointer text-sky-900 text-sm font-medium"
                >
                  Select all
                </div>
                <div
                  onClick={() => setSelectedBranches([])}
                  className="cursor-pointer text-sky-900 text-sm font-medium"
                >
                  Reset
                </div>
              </div>
              <button
                disabled={!selectedBranches.length}
                onClick={() => {
                  localStorage.setItem(
                    "selectedBranches",
                    JSON.stringify(selectedBranches)
                  );
                  setShowDropdown(false);
                  window.location.reload();
                }}
                className="disabled:opacity-50 cursor-pointer text-right text-sky-900 text-sm font-medium"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectBranch;
